/**
 * Logs a caught exception so callers satisfy Sonar S2486 (exceptions must not be ignored).
 * @param {unknown} error
 * @param {string} [contextMessage]
 */
export default function logCaughtException(error, contextMessage) {
  if (contextMessage) {
    console.error(contextMessage, error);
    return;
  }
  console.error(error);
}
